import { useConstant } from "./use-constant";

/** Returns true if the user is using a mobile/tablet */
export const useIsMobileUser = () => {
    const isMobile = useConstant(() => /iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    return isMobile;
};
